import styled, { keyframes } from 'styled-components';
import white from 'sushiweb/tokens/color/white';
import grey from 'sushiweb/tokens/color/grey';
import Button from 'sushiweb/Button';
import black from 'sushiweb/tokens/color/black';
import green from 'sushiweb/tokens/color/green';
import red from 'sushiweb/tokens/color/red';
import { uploadErrorStatus } from '../../../common/components/constants';

export const FooterWrapper = styled.div`
  background: ${white};
  padding: 0 2rem;
  border-top: 0.1rem solid ${grey.z200};
  width: 100%;
  position: fixed;
  bottom: 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: 'row-reverse';
`;

export const Footer = styled.div`
  width: 100%;
  max-width: 110rem;
  height: 7.2rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 4;
`;

export const RightButton = styled(Button)`
  position: absolute;
  right: 0;
`;

export const StyledButton = styled(Button)`
  margin-left: 2rem;
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 110rem;
  margin-top: 1.5rem;
  p {
    margin-top: 1.4rem;
    font-size: 1.6rem;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  margin: 2.4rem 0;
  background: ${white};
  border: 0.1rem solid ${grey.z200};
  border-radius: 0.8rem;
  padding: 3.4rem 2.6rem;
  h5 {
    /* margin-bottom: 2.4rem; */
  }
  p {
    font-size: 1.7rem;
  }
`;

const move = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
`;

export const ConfirmUpload = styled.div`
  -webkit-transition: visibility 0s, opacity 0.2s linear;
  -moz-transition: visibility 0s, opacity 0.2s linear;
  transition: visibility 0s, opacity 0.2s linear;
  opacity: ${props => (props.show ? 1 : 0)};
  display: ${props => (props.show ? 'block' : 'none')};
  overflow: hidden;
  width: 100%;
  max-width: 110rem;
  margin-top: 2.8rem;
  padding: 2rem 3rem;
  font-weight: 500;
  color: ${props =>
    uploadErrorStatus.includes(props.status) ? red.z700 : green.z700};
  font-size: 1.6rem;
  border-radius: 1rem;
  border: ${props =>
    uploadErrorStatus.includes(props.status)
      ? `0.1rem solid ${red.z400}`
      : `0.1rem solid ${green.z400}`};
  background-color: ${props =>
    uploadErrorStatus.includes(props.status) ? red.z200 : green.z200};
  position: relative;
  &:after {
    display: ${props => (props.progress ? 'block' : 'none')};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
    background-size: 50px 50px;
    animation: ${move} 2s linear infinite;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${props => (props.large ? '-2.4rem' : '0')};
  width: ${props => (props.large ? '66%' : '100%')};
  p {
    font-size: 1.6rem;
    font-weight: 400;
    color: ${grey.z700};
  }
`;

export const ConfirmLabel = styled.div`
  display: flex;
  margin-top: 2.5rem;
  input {
    margin: 0.6rem 1.2rem 0 0;
    cursor: pointer;
    width: 1.8rem;
    height: 1.8rem;
  }
  p {
    font-size: 1.6rem;
    color: ${black};
  }
  a {
    display: contents;
    font-size: 1.6rem;
  }
`;
